import axios from "axios";
import getToken from "../../../config/getToken";
import { env } from "../../../env";

axios.interceptors.response.use(
  (response) => {
    if (response.data.responseCode === 1016 || response.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function GetCredentialNrps(mainUser, rfc) {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `credentialsnrps/${mainUser}/rfc/${rfc}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function UpdateNrp(data) {
  const token = await getToken();
  return axios({
    method: "PUT",
    url: "credentialsnrps",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function DeleteNrp(data) {
  const token = await getToken();
  return axios({
    method: "DELETE",
    url: "credentialsnrps",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
